import { render } from "./PurchaseHistoryPage.vue?vue&type=template&id=743fec9e"
import script from "./PurchaseHistoryPage.vue?vue&type=script&lang=js"
export * from "./PurchaseHistoryPage.vue?vue&type=script&lang=js"

import "./PurchaseHistoryPage.vue?vue&type=style&index=0&id=743fec9e&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__